import { useEffect, useState } from "react";
import { authStore } from "entities/Auth";
import { SeaSavedCardModel, seaSavedCardStore, useSavedCardsQuery } from "entities/SeaSavedCard";
import { SeaSearchCardModel } from "entities/SeaSearchCard";
import { useAppSelector } from "shared/lib/redux";

type UseSeaOpenedCardIsFollowButtonVisibleProps = {
  openedCard: SeaSavedCardModel | SeaSearchCardModel | null;
};

export const useSeaOpenedCardIsFollowButtonVisible = ({
  openedCard,
}: UseSeaOpenedCardIsFollowButtonVisibleProps): { isSeaFollowButtonVisible: boolean } => {
  // TODO: uncomment selectors
  const savedCards = useAppSelector(seaSavedCardStore.selectors.savedCards);
  // const cardsByTag = useTypedSelector((state) => state.panel.cardsByTag);
  // const filteredCards = useTypedSelector((state) => state.panel.filteredCards);
  const isAuthenticated = useAppSelector(authStore.selectors.isAuthenticated);

  const { getCards, cancelGetCardsRequest } = useSavedCardsQuery({ queryKey: ["openedCardIsFollowButtonVisible"] });

  const [isSeaFollowButtonVisible, setIsSeaFollowButtonVisible] = useState(false);

  useEffect(() => {
    const reference = openedCard?.reference;
    if (!reference || !isAuthenticated) return;
    // TODO: add cardsByTag and filteredCards
    const allCards = [...savedCards];

    if (allCards.length) {
      const isCardSaved = !!allCards.find((card) => card.reference === reference);
      setIsSeaFollowButtonVisible(!isCardSaved);
      return;
    }

    getCards(
      { where: { reference } },
      {
        onSettled: (response) => {
          const isSavedCardFound = !!response?.length;
          setIsSeaFollowButtonVisible(!isSavedCardFound);
        },
      }
    );

    return () => {
      cancelGetCardsRequest();
    };
    //TODO: add cardsByTag and filteredCards
  }, [savedCards.length, openedCard?.reference]);

  return { isSeaFollowButtonVisible };
};
